import BuildingGraphic from '@/assets/building-thalo-graphic.png';

const ComingSoon = ({ heading = "Coming soon!", secondary_text = "This feature is still under development.", tertiary_text = "" }) => {
    return (
        <div className="flex items-center justify-center ">
            <div className="text-center p-16" >
                <h1 className="text-2xl font-bold mt-16 sm:text-6xl [text-wrap:balance]">
                    {heading}
                </h1>
                <p className="mt-12 text-lg [text-wrap:balance]">
                    {secondary_text}
                </p>
                <p className="mt-12 text-lg [text-wrap:balance]">
                    {tertiary_text}
                </p>
                <img src={BuildingGraphic} alt="Building Graphic" className=" w-96 h-96 mx-auto mt-12" />
            </div>
        </div>
    );
};

export default ComingSoon;
